import axios from 'axios';
import {flashMessage} from 'redux-flash';
import Config from '../../config';
import {single as pageSingle, structure} from "./content";
import {single as blockSingle} from "./block";
import {setLanguage, setLanguages} from "../../admin/store/actions/language";
import _ from "lodash";

export function onLanguageChange(routeParams) {
    return (dispatch) => {
        const {block, page, workspace, language} = routeParams;

        dispatch(setLanguages());
        dispatch(setLanguage(language));
        dispatch(getGlobals(false));

        if (workspace) {
            dispatch(structure(workspace))
        }

        if (block) {
            dispatch(blockSingle(block, language))
        }

        if (page) {
            dispatch(pageSingle(page, language))
        }
    }
}

export function getGlobalsForWorkspace(parentWorkspaceId) {
    return async (dispatch) => {
        const structure = await axios.get(Config.api.endpoint + 'api/content/structure/' + parentWorkspaceId + '/page', Config.getApiConfig());
        const blocks = await axios.get(Config.api.endpoint + 'api/content/structure/' + parentWorkspaceId + '/block', Config.getApiConfig());

        dispatch({
            type: 'GET_GLOBALS_FOR_WORKSPACE',
            payload: {
                structure: structure.data,
                blocks: blocks.data,
                parentWorkspaceId: parentWorkspaceId,
            }
        });

        return Promise.resolve({
            structure: structure.data,
            blocks: blocks.data,
            parentWorkspaceId: parentWorkspaceId
        });
    }
}

export function getGlobals(languageCode, menu = true) {
    return async (dispatch) => {
        if (menu) {
            dispatch({
                type: 'MENU_START_GET',
                payload: {
                    type: 'global-fields'
                }
            });
        }

        const contentDefinition = await axios.get(Config.api.endpoint + 'api/Content/definition', Config.getApiConfig());
        const language = await axios.get(Config.api.endpoint + 'api/Language', Config.getApiConfig());
        const global = await axios.get(Config.api.endpoint + 'api/global/field/' + languageCode, Config.getApiConfig());

        if (menu) {
            dispatch({
                type: 'MENU_GET_SUCCESS',
                payload: {
                    type: 'global-fields',
                    data: global.data
                }
            });
        }

        dispatch({
            type: 'GET_GLOBALS',
            payload: {
                contentDefinitions: contentDefinition.data,
                languages: language.data,
                global: global.data
            }
        });

        return Promise.resolve({
            contentDefinitions: contentDefinition.data,
            languages: language.data,
            global: global.data
        });
    }
}

export function getSingle(key, languageCode, languages, backOffice = false) {
    const queryParams = {
        backOffice: backOffice
    };

    const queryParamsString = new URLSearchParams(queryParams).toString();

    return (dispatch) => {
        return axios.get(`${Config.api.endpoint}api/global/field/${key}/${languageCode}?${queryParamsString}`, Config.getApiConfig()).then(response => {
            if (response.data) {
                const languageFieldData = {};

                languages.forEach((language) => {
                    const find = _.find(response.data.languageFieldData, (item) => item.language.code === language.id);

                    if (find) {
                        let data = '';

                        try {
                            data = JSON.parse(find.data);
                        } catch (e) {
                            data = find.data;
                        }

                        languageFieldData[language.id] = {
                            data: data,
                            language: {
                                code: language.id,
                                title: language.title
                            }
                        };
                    } else {
                        languageFieldData[language.id] = {
                            data: "",
                            language: {
                                code: language.id,
                                title: language.title
                            }
                        };
                    }
                });

                dispatch({
                    type: 'GLOBAL_FIELD_GET_SINGLE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'GlobalFieldForm',
                        keepDirty: undefined
                    },
                    payload: {
                        fieldDefinitionType: response.data.fieldDefinitionType,
                        languageFieldData: languageFieldData,
                        key: response.data.key,
                        languageId: languageCode
                    }
                });

                return response;
            }
        })
    }
}

export function patch(key, languageCode, value) {
    return (dispatch) => {
        return axios.patch(Config.api.endpoint + 'api/global/field/' + languageCode, value, Config.getApiConfig({headers: {'Content-Type': 'application/json-patch+json'}})).then(response => {
            if (response.data) {
                dispatch(getSingle(key, languageCode));

                dispatch({
                    type: 'GLOBAL_FIELD_PATCH_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Global field updated!', {
                    timeout: 3000,
                    props: {type: 'success'}
                }));

                return response;
            }
        })
    }
}

export function getAll(languageCode) {
    return (dispatch) => {
        dispatch({
            type: 'GLOBAL_FIELD_GET_ALL_LOADING',
            payload: true
        });

        return axios.get(Config.api.endpoint + 'api/global/field/' + languageCode, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_GET_ALL_SUCCESS',
                    payload: response.data
                });

                return response;
            } else {
                dispatch({
                    type: 'GLOBAL_FIELD_GET_ALL_SUCCESS',
                    payload: []
                });

                return response;
            }
        }).catch(error => {
            dispatch({
                type: 'GLOBAL_FIELD_GET_ALL_FAILED',
                payload: true
            });

            return false;
        });
    }
}


// return axios.post2(Config.api.endpoint + 'api/Global/field/'+languageCode, postData, Config.getApiConfig()).then(response => {
//     if (response.data) {
//         dispatch({
//             type: 'GLOBAL_FIELD_POST_SUCCESS',
//             payload: {
//                 data: response.data
//             }
//         });
//
//         dispatch(flashMessage('Global field created!', {
//             timeout: 3000,
//             props: {type: 'success'}
//         }));
//
//         dispatch(getAll(languageCode));
//
//         dispatch(getGlobals(languageCode));
//
//         for (let x in values.languageFieldData) {
//             let langData = values.languageFieldData[x];
//             console.log(values.key, langData.language.code, langData.language.data);
//             dispatch(patch(values.key, langData.language.code, langData.language.data));
//         }
//
//         return response;
//     }
// })

export function post(values, languageCode) {

    const postData = {
        ...values
    };

    for (let x in postData.languageFieldData) {
        postData.languageFieldData[x].data = typeof (postData.languageFieldData[x].data) === "string" ? postData.languageFieldData[x].data : JSON.stringify(postData.languageFieldData[x].data);
    }

    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/global/field/' + languageCode, postData, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Global field created!', {
                    timeout: 3000,
                    props: {type: 'success'}
                }));

                dispatch(getAll(languageCode));

                dispatch(getGlobals(languageCode));

                return response;
            }
        })
    }
}

export function destroy(key, languageCode) {
    return (dispatch) => {
        return axios.delete(Config.api.endpoint + 'api/global/field/' + key, Config.getApiConfig()).then(response => {
            dispatch({
                type: 'GLOBAL_FIELD_DESTROY_SUCCESS',
                payload: {
                    data: response.data
                }
            });

            dispatch(flashMessage('Global field deleted!', {
                timeout: 3000,
                props: {type: 'success'}
            }));

            dispatch(getAll(languageCode));
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/store/actions/global.js